import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from "@angular/core";
import { TechnicalDataService } from "../technical-data.service";
import { Subscription } from "rxjs";
import { Group, Vehicule } from "../../../model/data-managemnt";
import { DataManagementService } from "../../data-management/data-management.service";
import { SigninService } from '../../../signin/signin.service';
import { DeviceCarb, DeviceOpt, TechnicalData } from "../../../model/technical-data";
import { Router } from "@angular/router";
import { GlobalService } from "../../../global.config";
import { ChartFullscreenService } from "../../../utils/chart-fullscreen/chart-fullscreen.service";
import { IonModal, ModalController } from "@ionic/angular";
import { MapService } from "../../../utils/leaflet/service/map.service";
import { MapNavigationService } from "../../../utils/map-top-toolbar/map-navigation.service";
import { GeocodingService } from "../../../utils/leaflet/service/geocoding.service";

import * as Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);
import { IDropdownSettings, MultiSelectComponent } from "ng-multiselect-dropdown";
import * as L from 'leaflet';
import { Icon, Marker } from 'leaflet';

@Component({
  selector: "app-technical-data",
  templateUrl: "./technical-data.component.html",
  styleUrls: ["./technical-data.component.scss"]
})
export class TechnicalDataComponent implements OnInit {
  @Input() overlayOnly = false;
  @ViewChild('startDateModal') startDateModal: IonModal;
  @ViewChild('endDateModal') endDateModal: IonModal;
  @ViewChild('technicalOptionsDropdown') technicalOptionsDropdown?: MultiSelectComponent;

  optionsDropdownSettings :IDropdownSettings =  {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  optionsItems: any = [];
  selectedOptionItems: { item_text: string; item_id: number }[] = [];

  //Chart vars
  chart: any;
  options: any;
  serieName: any;

  //Device Options
  deviceopt: DeviceOpt;

  //Device Carburant
  devicecarb: DeviceCarb;

  AllGroups: Subscription;
  vehicule: Vehicule;

  technicaldata: TechnicalData[];

  //MultiSelelct vars
  dropdownList = [];
  selectItems = [];
  dropdownSettings = {};

  isResultLoaded: boolean = true;
  formNotShown = false;

  isGroupLoaded = false;

  lastRefresh: Date;

  fullscreenChartId: string | null = null;

  private startPickerState: { date: string; hour: number; minute: number } | null = null;
  private endPickerState: { date: string; hour: number; minute: number } | null = null;
  private startOpenSnapshot: { date: string; hour: number; minute: number } | null = null;
  private endOpenSnapshot: { date: string; hour: number; minute: number } | null = null;
  private startDismissTimer: ReturnType<typeof setTimeout>;
  private endDismissTimer: ReturnType<typeof setTimeout>;

  // --- Map lifecycle (mirrors FuelDataComponent / TempDataComponent) ---
  private techReportMap: L.Map | null = null;
  private techReportMarker: Marker | null = null;
  private techReportBaseMaps: Record<string, L.TileLayer> | null = null;
  private mapLayerSubscription?: Subscription;

  selected: any = {
    startDate: new Date(new Date().setHours(0, 0, 0, 0) + (60 * 60 * 1000)).toISOString(),
    endDate: new Date(new Date().setHours(23, 59, 59, 999) + (60 * 60 * 1000)).toISOString(),
  };

  constructor(
    private technicaldataservice: TechnicalDataService,
    public dataManagementService: DataManagementService,
    public toastr: ToastrService,
    public signinService: SigninService,
    private globalService: GlobalService,
    private router: Router,
    private chartFullscreenService: ChartFullscreenService,
    private modalController: ModalController,
    private mapService: MapService,
    private mapNavigationService: MapNavigationService,
    private geocodingService: GeocodingService,
    private cdr: ChangeDetectorRef,
  ) {}

  get hasFilteredResults(): boolean {
    return !!this.options;
  }

  get showDefaultFilteredLayout(): boolean {
    return this.hasFilteredResults && !this.fullscreenChartId;
  }

  closeFilterForm(): void {
    if (this.hasFilteredResults) {
      this.formNotShown = true;
      setTimeout(() => (this.options as any)?.reflow?.(), 200);
      return;
    }
    void this.close();
  }

  ionViewWillEnter() {
    this.dataManagementService.ensureSelectedVehicle();
  }

  ionViewWillLeave() {
    this.exitChartFullscreen();
    this.destroyTechReportMap();
  }

  isChartFullscreen(chartId: string): boolean {
    return this.fullscreenChartId === chartId;
  }

  async toggleChartFullscreen(chartId: string, chart: any): Promise<void> {
    const exiting = this.fullscreenChartId === chartId;

    if (exiting) {
      // Leave fullscreen → restore default filtered layout (graph + map).
      this.destroyTechReportMap();
      this.fullscreenChartId = null;
      this.formNotShown = true;
      this.cdr.detectChanges();
      await this.chartFullscreenService.exitLandscape();
      this.cdr.detectChanges();
      setTimeout(() => this.restoreFilteredResultsLayout(), 50);
      setTimeout(() => this.restoreFilteredResultsLayout(), 400);
      setTimeout(() => this.restoreFilteredResultsLayout(), 800);
      return;
    }

    // Enter fullscreen — tear down map so Leaflet is not left on a hidden node.
    this.destroyTechReportMap();
    if (this.fullscreenChartId) {
      this.fullscreenChartId = null;
      await this.chartFullscreenService.exitLandscape();
    }
    this.fullscreenChartId = chartId;
    this.cdr.detectChanges();
    await this.chartFullscreenService.enterLandscape();
    this.chartFullscreenService.scheduleReflow(chart);
  }

  private async exitChartFullscreen(): Promise<void> {
    if (!this.fullscreenChartId) {
      return;
    }
    this.destroyTechReportMap();
    this.fullscreenChartId = null;
    this.formNotShown = true;
    this.cdr.detectChanges();
    await this.chartFullscreenService.exitLandscape();
    this.chartFullscreenService.scheduleReflow(this.options as any);
    setTimeout(() => this.restoreFilteredResultsLayout(), 50);
    setTimeout(() => this.restoreFilteredResultsLayout(), 400);
  }

  /** Rebuild the post-filter layout: graph + Position du point map (same as Carburant/Température). */
  private restoreFilteredResultsLayout(): void {
    if (!this.hasFilteredResults) {
      return;
    }

    this.formNotShown = true;
    this.cdr.detectChanges();

    const chartEl = document.getElementById('container') as HTMLElement | null;
    if (chartEl) {
      const targetH = Math.max(160, Math.round(window.innerHeight * 0.28));
      chartEl.style.height = `${targetH}px`;
      chartEl.style.maxHeight = `${targetH}px`;
      chartEl.style.minHeight = '0';
      const w = chartEl.clientWidth || Math.round(window.innerWidth - 24);
      if ((this.options as any)?.setSize) {
        (this.options as any).setSize(w, targetH, false);
      } else {
        (this.options as any)?.reflow?.();
      }
    }

    // Map was removed from DOM during fullscreen — recreate the default point.
    if (!this.techReportMap && document.getElementById('map')) {
      this.showInitialMapPoint();
    } else if (this.techReportMap) {
      try {
        this.techReportMap.invalidateSize(true);
      } catch {
        this.destroyTechReportMap();
        this.showInitialMapPoint();
      }
    }
  }

  dateHandle(event: any, type: string) {
    const value = event.detail.value;
    if (!value) {
      return;
    }

    const state = this.toPickerState(value);

    if (type === 'start') {
      this.selected.startDate = value;
      this.handleDateTimePickerChange('start', state);
    } else {
      this.selected.endDate = value;
      this.handleDateTimePickerChange('end', state);
    }
  }

  onDateModalOpen(type: 'start' | 'end') {
    const value = type === 'start' ? this.selected.startDate : this.selected.endDate;
    const snapshot = this.toPickerState(value);

    if (type === 'start') {
      this.startPickerState = null;
      this.startOpenSnapshot = snapshot;
      clearTimeout(this.startDismissTimer);
    } else {
      this.endPickerState = null;
      this.endOpenSnapshot = snapshot;
      clearTimeout(this.endDismissTimer);
    }
  }

  private toPickerState(value: string) {
    const parsed = new Date(value);
    return {
      date: `${parsed.getFullYear()}-${parsed.getMonth()}-${parsed.getDate()}`,
      hour: parsed.getHours(),
      minute: parsed.getMinutes(),
    };
  }

  private handleDateTimePickerChange(
    type: 'start' | 'end',
    state: { date: string; hour: number; minute: number }
  ) {
    const modal = type === 'start' ? this.startDateModal : this.endDateModal;
    const openSnapshot = type === 'start' ? this.startOpenSnapshot : this.endOpenSnapshot;

    if (type === 'start') {
      this.startPickerState = state;
    } else {
      this.endPickerState = state;
    }

    // Ignore the change fired right after opening (value unchanged from open).
    if (openSnapshot &&
        openSnapshot.date === state.date &&
        openSnapshot.hour === state.hour &&
        openSnapshot.minute === state.minute) {
      return;
    }

    // Close shortly after the user stops choosing (date then time resets the timer).
    this.scheduleDateModalDismiss(type, modal);
  }

  private scheduleDateModalDismiss(type: 'start' | 'end', modal: IonModal) {
    const timer = setTimeout(() => {
      this.resetDatePickerState(type);
      void modal?.dismiss();
    }, 500);

    if (type === 'start') {
      clearTimeout(this.startDismissTimer);
      this.startDismissTimer = timer;
    } else {
      clearTimeout(this.endDismissTimer);
      this.endDismissTimer = timer;
    }
  }

  private resetDatePickerState(type: 'start' | 'end') {
    if (type === 'start') {
      this.startPickerState = null;
      this.startOpenSnapshot = null;
      clearTimeout(this.startDismissTimer);
    } else {
      this.endPickerState = null;
      this.endOpenSnapshot = null;
      clearTimeout(this.endDismissTimer);
    }
  }

  async close() {
    this.destroyTechReportMap();
    this.mapNavigationService.setToolbarHidden(false);
    if (this.overlayOnly) {
      this.mapService.preventMapDestroy = false;
      try {
        await this.modalController.dismiss();
      } catch {}
      this.mapNavigationService.requestRealtimeMap();
      return;
    }
    try {
      await this.modalController.dismiss();
    } catch {
      this.router.navigate(['/client']);
      return;
    }
    this.mapNavigationService.requestRealtimeMap();
  }

  ngOnInit() {
    this.mapNavigationService.setToolbarHidden(true);
    if (this.overlayOnly) {
      this.formNotShown = false;
      this.mapService.preventMapDestroy = true;
    }

    //init multiselect
    this.dropdownSettings = {
      singleSelection: false,
      text: "Select option",
      selectAllText: "Select Tous",
      unSelectAllText: "UnSelect Tous",
      enableSearchFilter: false,
      classes: "custom-class-multiselect",
      badgeShowLimit: 1
    };

    // Keep the map's base layer in sync with the layer picker, same as Carburant/Température.
    this.mapLayerSubscription = this.mapService.mapLayerChange$.subscribe((layerKey) => {
      if (this.techReportMap) {
        this.mapService.applyMapLayerToMap(this.techReportMap, layerKey);
      }
    });

    // Overlay mode: reuse already-loaded groups (don't re-init realtime data).
    if (this.overlayOnly) {
      if (this.dataManagementService.groups?.length > 0) {
        if (!this.dataManagementService.selectedGroup) {
          this.dataManagementService.selectedGroup = this.dataManagementService.groups[0];
        }
        if (!this.dataManagementService.selectedVehicule && this.dataManagementService.selectedGroup?.vehicules?.length > 0) {
          this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
        }
        if (this.dataManagementService.selectedVehicule) {
          this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
        }
      }
      return;
    }

    this.dataManagementService.GroupsLoaded$.subscribe(groups => this.onGroupLoaded(groups));
    this.dataManagementService.init();
    if (this.dataManagementService.selectedVehicule)
      this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
  }


  onGroupLoaded(groups: Group[]) {
    if (this.dataManagementService.groups) {
      this.isGroupLoaded = true;
      if (this.dataManagementService.selectedVehicule)
        this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
    }
  }

  ngOnDestroy() {
    this.mapLayerSubscription?.unsubscribe();
    this.mapNavigationService.setToolbarHidden(false);
    this.resetDatePickerState('start');
    this.resetDatePickerState('end');
    if (this.AllGroups) this.AllGroups.unsubscribe();
  }

  deleteItemById(itemId) {
    this.optionsItems = this.optionsItems.filter(item => item.item_id !== itemId);
  }
  //Get Device Options and fill the dropdownList
  getDeviceOpt(deviceid: number) {
    this.selectedOptionItems = [];
    this.dropdownList = [];
    this.optionsItems = [
      { "item_id": 0, "item_text": "RPM" },
      { "item_id": 1, "item_text": "Vitesse" },
      // { "item_id": 2, "item_text": "Carburant Total" },
      { "item_id": 3, "item_text": "Carburant" },
      // { "item_id": 4, "item_text": "Vitesse" },
      { "item_id": 5, "item_text": "Temp Moteur" },
      { "item_id": 6, "item_text": "Consomation Inst" },
    ];
    this.isResultLoaded = false;
    this.technicaldataservice.getDeviceOpt(deviceid).subscribe(response => {
      this.deviceopt = response;
      // this.dropdownList.push({ id: 1, option: "ignition,speed", itemName: "Vitesse" });
      if (
        this.deviceopt.useFuel === 0 &&
        this.deviceopt.useFms === 0 &&
        this.deviceopt.useJ1708 === 0
      ) {
        this.deleteItemById(3)
      }
      if (this.deviceopt.useFms === 0 && this.deviceopt.useJ1708 === 0) {
        this.deleteItemById(0);
        this.deleteItemById(5);
        this.deleteItemById(6);
      }
      this.isResultLoaded = true;
    });
  }

  onItemSelect(item: any) {
  }

  onTechnicalOptionSelect(dropdown: MultiSelectComponent): void {
    setTimeout(() => this.closeTechnicalOptionsDropdownIfAllSelected(dropdown), 0);
  }

  onTechnicalOptionSelectAll(dropdown: MultiSelectComponent): void {
    setTimeout(() => this.closeTechnicalOptionsDropdown(dropdown), 0);
  }

  onTechnicalOptionsModelChange(items: { item_id: number }[]): void {
    const available = this.optionsItems || [];
    if (available.length > 0 && items?.length >= available.length) {
      this.closeTechnicalOptionsDropdown();
    }
  }

  private closeTechnicalOptionsDropdownIfAllSelected(dropdown?: MultiSelectComponent): void {
    const target = dropdown ?? this.technicalOptionsDropdown;
    if (target?.isAllItemsSelected()) {
      this.closeTechnicalOptionsDropdown(target);
    }
  }

  private closeTechnicalOptionsDropdown(dropdown?: MultiSelectComponent): void {
    const target = dropdown ?? this.technicalOptionsDropdown;
    target?.closeDropdown();
    this.optionsDropdownSettings = {
      ...this.optionsDropdownSettings,
      defaultOpen: false,
    };
  }

  displayChart() {
    this.isResultLoaded = false;
    this.selectItems = [];
    this.selectedOptionItems.forEach(item => {
      const itemMapping = {
        0: {"id": 0, "option": "ignition,rpm", "itemName": "RPM"},
        1: { "id": 1, "option": "ignition,speed", "itemName": "Vitesse" },
        3: {"id": 3, "option": "ignition,fuel", "itemName": "Carburant"},
        5: {"id": 5, "option": "ignition,temp_engine", "itemName": "Temp Moteur"},
        6: {"id": 6, "option": "ignition,fuel_rate", "itemName": "Consomation Inst"}
      };

      if (itemMapping[item.item_id]) {
        this.selectItems.push(itemMapping[item.item_id]);
      }
    });
    this.lastRefresh = new Date();
    //Get Selected Options
    let devopt = [];
    if (this.selectItems.length > 0) {
      this.selectItems.forEach(itm => {
        devopt.push(itm.option);
      });
    }

    // Always request coordinates + ignition so the "Position du point" map works,
    // same as Carburant/Température, regardless of which options were selected.
    const mapFields = ['latitude', 'longitude', 'ignition'];
    mapFields.forEach(f => {
      if (!devopt.includes(f)) {
        devopt.push(f);
      }
    });

    // Options vars
    let speed = [];
    let fuel = [];
    let temp = [];
    let ignition = [];
    let rpm = [];
    let temp_engine = [];
    let fuel_rate = [];
    let ok: boolean = false;

    //Select data Device carburant
    this.technicaldataservice
      .getDeviceCarb(this.dataManagementService.selectedVehicule.device.idDevice)
      .subscribe(res => {
        this.devicecarb = res;
      });

    //Get Fuel Data and fill all options
    this.technicaldataservice
      .getFuelDetail(
        this.dataManagementService.selectedVehicule.device.idDevice,
        {
          startDate: this.selected.startDate,
          endDate: this.selected.endDate
        },
        devopt
      )
      .subscribe(res => {
        this.technicaldata = res;
        if (this.technicaldata.length == 0) {
          this.toastr.warning("Pas de données à afficher");
        }
        this.technicaldata.forEach(stat => {
          if (stat.speed != undefined) {
            speed.push({ x: stat.date, y: stat.speed });
          }
          if (stat.fuel != undefined) {
            if (this.devicecarb.max - this.devicecarb.min > 0) {
              if (
                stat.fuel >= this.devicecarb.min &&
                stat.fuel <= this.devicecarb.max
              ) {
                fuel.push({
                  x: stat.date,
                  y:
                    ((stat.fuel - this.devicecarb.min) /
                      (this.devicecarb.max - this.devicecarb.min)) *
                    this.devicecarb.volume
                });
              }
            } else {
              if (
                stat.fuel >= this.devicecarb.max &&
                stat.fuel <= this.devicecarb.min
              ) {
                fuel.push({
                  x: stat.date,
                  y:
                    ((stat.fuel - this.devicecarb.min) /
                      (this.devicecarb.max - this.devicecarb.min)) *
                    this.devicecarb.volume
                });
              }
            }
          }
          if (stat.ignition != undefined) {
            ignition.push({ x: stat.date, y: stat.ignition ? 1 : 0 });
            ok = true;
          }
          if (stat.rpm != undefined && ok == true) {
            rpm.push({ x: stat.date, y: stat.rpm });
          }
          if (stat.temp_engine != undefined && ok == true) {
            temp_engine.push({ x: stat.date, y: stat.temp_engine });
          }
          if (stat.fuel_rate != undefined && ok == true) {
            fuel_rate.push({ x: stat.date, y: stat.fuel_rate });
          }
        });

        //Charts vars
        let serie = [];
        let yaxis = [];

        for (let i = 1; i < ignition.length; i++) {
          if (
            ignition[i].y > ignition[i - 1].y ||
            ignition[i].y < ignition[i - 1].y
          ) {
            ignition[i].x = ignition[i - 1].x;
          }
        }

        //Fill all series and yxais
        if (this.ChartSeries(ignition) == true) {
          yaxis.push({
            title: {
              text: "Ignition",
              style: {
                color: "rgb(255, 127, 0)"
              }
            },
            labels: {
              style: {
                color: "rgb(255, 127, 0)"
              }
            },
            min: 0,
            max: 1,
            alignTicks: false,
            endOnTick: false,
            tickInterval: 1
          });
          serie.push({
            name: "Ignition",
            type: "area",
            color: "rgb(255, 127, 0)",
            data: ignition,
            yAxis: this.PositionYaxis(yaxis, "Ignition")
          });
        }
        if (this.ChartSeries(speed) == true) {
          yaxis.push({
            title: {
              text: "vitesse",
              style: {
                color: "rgb(44, 161, 33)"
              }
            },
            labels: {
              format: "{value} " + "Km/h",
              style: {
                color: "rgb(44, 161, 33)"
              }
            },
            min: 0
          });
          serie.push({
            name: "Vitesse",
            data: speed,
            color: "rgb(44, 161, 33)",
            yAxis: this.PositionYaxis(yaxis, "vitesse"),
            tooltip: {
              valueSuffix: "KM/H",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(fuel) == true) {
          yaxis.push({
            title: {
              text: "carburant",
              style: {
                color: "rgb(23, 119, 182)"
              }
            },
            labels: {
              format: "{value} " + "L",
              style: {
                color: "rgb(23, 119, 182)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "Carburant",
            data: fuel,
            color: "rgb(23, 119, 182)",
            yAxis: this.PositionYaxis(yaxis, "carburant"),
            tooltip: {
              valueSuffix: "L",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(temp) == true) {
          yaxis.push({
            title: {
              text: "temperature",
              style: {
                color: "rgb(107, 57, 156)"
              }
            },
            labels: {
              format: "{value} " + "°C",
              style: {
                color: "rgb(107, 57, 156)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "Temperature",
            data: temp,
            color: "rgb(107, 57, 156)",
            yAxis: this.PositionYaxis(yaxis, "temperature"),
            tooltip: {
              valueSuffix: "°C",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(rpm) == true) {
          yaxis.push({
            title: {
              text: "RPM",
              style: {
                color: "rgb(230, 20, 9)"
              }
            },
            labels: {
              format: "{value} " + "Tr/Min",
              style: {
                color: "rgb(230, 20, 9)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "rpm",
            data: rpm,
            color: "rgb(230, 20, 9)",
            yAxis: this.PositionYaxis(yaxis, "RPM"),
            tooltip: {
              valueSuffix: "Tr/Min",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(temp_engine) == true) {
          yaxis.push({
            title: {
              text: "temp Moteur",
              style: {
                color: "rgb(179, 89, 31)"
              }
            },
            labels: {
              format: "{value} " + "°C",
              style: {
                color: "rgb(179, 89, 31)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "Temp Moteur",
            data: temp_engine,
            color: "rgb(179, 89, 31)",
            yAxis: this.PositionYaxis(yaxis, "temp Moteur"),
            tooltip: {
              valueSuffix: "°C",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(fuel_rate) == true) {
          yaxis.push({
            title: {
              text: "Consomation Inst",
              style: {
                color: "rgb(75,93,157)"
              }
            },
            labels: {
              format: "{value} " + "L",
              style: {
                color: "rgb(75,93,157)"
              }
            },
            min: 0
          });
          serie.push({
            name: "Consomation Inst",
            data: fuel_rate,
            color: "rgb(75,93,157)",
            yAxis: this.PositionYaxis(yaxis, "Consomation Inst"),
            tooltip: {
              valueSuffix: "°C",
              valueDecimals: 2
            }
          });
        }

        //Create a new HighChart
        this.options = new Highcharts.Chart({
          time: {
            timezoneOffset: this.globalService.time_difference
          },
          title: { text: "Véhicule: " + this.dataManagementService.selectedVehicule.matricule },
          chart: {
            type: "spline",
            renderTo: "container",
            height: 420,
            zoomType: "x"
          } as any,

          xAxis: [
            {
              type: "datetime",
              tickInterval: 3600 * 1000,
              labels: {
                formatter: function () {
                  return Highcharts.dateFormat("%d/%m/%Y %H:%M", Number(this.value));
                }
              },
              crosshair: true
            }
          ],

          yAxis: yaxis,

          plotOptions: {
            series: {
              turboThreshold: 100000,
              events: {
                click: (event) => {
                  this.getPathDatails(this.dataManagementService.selectedVehicule.device.idDevice, event.point.x, event.point.x);
                },
              },
            }
          },

          series: serie
        });
        this.isResultLoaded = true;

        // Auto-show a default point on the map, exactly like Carburant/Température do after search.
        this.scheduleInitialMapPoint();
      });

  }

  //Return the position of Yaxis
  PositionYaxis(data: any, option: string): number {
    for (let i = 0; i < data.length; i++) {
      if (data[i].title.text === option) {
        return i;
      }
    }
    return -1;
  }

  //check if the series is empty or not
  ChartSeries(data: any = []) {
    let ok: boolean;
    data.forEach(dt => {
      ok = dt.y == undefined ? false : true;
    });
    return ok;
  }

  saveInstance(chartInstance) {
    this.chart = chartInstance;
  }

  onSeriesMouseOver(e) {
    this.serieName = e.context.name;
  }

  chooseGroup(group) {
    this.dataManagementService.selectedGroup = group;
    if (this.dataManagementService.selectedGroup.vehicules.length > 0 && this.dataManagementService.selectedGroup) {
      this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
      this.selectItems = [];
    }
  }

  chooseVehicule(vehicule) {
    this.dataManagementService.selectedVehicule = vehicule;
    this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
    this.selectItems = [];
  }

  // ---------------------------------------------------------------------
  // Map lifecycle — mirrors FuelDataComponent / TempDataComponent exactly.
  // ---------------------------------------------------------------------

  private destroyTechReportMap(): void {
    if (this.techReportMarker && this.techReportMap) {
      this.techReportMap.removeLayer(this.techReportMarker);
    }
    this.techReportMarker = null;

    if (this.techReportMap) {
      this.techReportMap.remove();
      this.techReportMap = null;
    }

    this.techReportBaseMaps = null;

    const container = document.getElementById('map');
    if (container) {
      container.replaceChildren();
      delete (container as HTMLElement & { _leaflet_id?: number })._leaflet_id;
    }
  }

  private refreshTechReportMapSize(map: L.Map): void {
    map.invalidateSize(true);
    setTimeout(() => map.invalidateSize(true), 150);
    setTimeout(() => map.invalidateSize(true), 450);
  }

  private createTechReportMap(): L.Map | null {
    const container = document.getElementById('map');
    if (!container) {
      return null;
    }

    this.mapService.ensureBaseMaps();
    this.techReportBaseMaps = this.mapService.createFreshBaseMapLayers() as Record<string, L.TileLayer>;
    const layerKey = this.mapService.resolveMapLayerKey();
    const tileLayer = this.techReportBaseMaps[layerKey] ?? this.techReportBaseMaps.OpenStreetMap;

    const map = L.map(container, {
      zoomControl: false,
      center: L.latLng(36.850457, 10.225097),
      zoom: 6,
      minZoom: 3,
      maxZoom: 20,
      layers: [tileLayer],
    } as L.MapOptions);

    L.control.layers(this.techReportBaseMaps, undefined, { position: 'bottomright' }).addTo(map);
    L.control.zoom({ position: 'bottomright' }).addTo(map);

    this.techReportMap = map;
    return map;
  }

  private buildTechMarkerIcon(ignition: boolean): Icon {
    const base = (this.globalService.imagesCarsDir || this.globalService.getimagesCarsDir?.() || '').replace(/\/$/, '');
    const iconUrl = `${base}/${ignition ? 'c1x0.png' : 'c3x0.png'}`;
    return new Icon({
      iconUrl,
      iconSize: [40, 40],
      shadowSize: [40, 40],
      iconAnchor: [20, 20],
      shadowAnchor: [20, 20],
      popupAnchor: [10, -10],
    });
  }

  private hasValidCoordinates(data: any): boolean {
    const lat = Number(data?.latitude);
    const lng = Number(data?.longitude);
    return Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);
  }

  private showTechPointOnMap(data: any): void {
    const map = this.techReportMap;
    if (!map || !this.hasValidCoordinates(data)) {
      this.toastr.warning('Aucune position disponible pour ce point');
      return;
    }

    const lat = Number(data.latitude);
    const lng = Number(data.longitude);

    if (this.techReportMarker) {
      map.removeLayer(this.techReportMarker);
    }

    const marker = new Marker([lat, lng], {
      icon: this.buildTechMarkerIcon(!!data.ignition),
    });
    let popup = '<div><b>Position</b></div>';

    this.geocodingService.inverseGeoconding(lat, lng, 7).subscribe(adress => {
      popup += `<div>${adress.display_name}</div>`;
      marker.bindPopup(popup);
    });

    marker.on('mouseover', () => marker.openPopup());
    marker.addTo(map);
    this.techReportMarker = marker;

    map.setView([lat, lng], 15, { animate: false });
    this.refreshTechReportMapSize(map);
  }

  private cachedPointData(source?: TechnicalData): { latitude: number; longitude: number; ignition?: boolean } | null {
    if (!source || !this.hasValidCoordinates(source)) {
      return null;
    }
    return {
      latitude: Number(source.latitude),
      longitude: Number(source.longitude),
      ignition: !!source.ignition,
    };
  }

  private findReportEntryForPoint(dateD: any, dateF: any): TechnicalData | undefined {
    const startMs = new Date(dateD).getTime();
    const endMs = new Date(dateF).getTime();
    return this.technicaldata?.find((d) => {
      const t = new Date(d.date).getTime();
      return t >= startMs && t <= endMs;
    });
  }

  private initTechReportMapForPoint(idDevice: number, dateD: any, dateF: any, cachedEntry?: TechnicalData): void {
    const mapCard = document.getElementById('map-card');
    if (mapCard) {
      mapCard.classList.add('visible');
    }

    this.destroyTechReportMap();
    this.cdr.detectChanges();

    setTimeout(() => {
      const map = this.createTechReportMap();
      if (!map) {
        return;
      }

      const showPoint = (data: { latitude: number; longitude: number; ignition?: boolean }): void => {
        map.whenReady(() => {
          this.refreshTechReportMapSize(map);
          this.showTechPointOnMap(data);
        });
      };

      const cached = this.cachedPointData(cachedEntry);
      if (cached) {
        showPoint(cached);
        return;
      }

      this.technicaldataservice.getFuelDetail(idDevice, {
        startDate: dateD,
        endDate: dateF
      }, ['latitude', 'longitude', 'ignition']).subscribe({
        next: (resp) => {
          const data = Array.isArray(resp) ? resp.find(item => !!item) || resp[0] : resp;
          if (!data || !this.hasValidCoordinates(data)) {
            this.toastr.warning('Aucune position disponible pour ce point');
            return;
          }
          if (this.techReportMap) {
            showPoint(data);
          }
        },
        error: () => {
          this.toastr.error('Aucune position disponible pour ce point');
        }
      });
    }, 200);
  }

  /** Auto-show the first available point after a search, same as Carburant/Température. */
  private scheduleInitialMapPoint(): void {
    setTimeout(() => {
      (this.options as any)?.reflow?.();
      this.cdr.detectChanges();
      this.showInitialMapPoint();
    }, 500);
  }

  private showInitialMapPoint(): boolean {
    const entry = this.technicaldata?.find(d => this.hasValidCoordinates(d));
    if (!entry) {
      return false;
    }
    this.initTechReportMapForPoint(
      this.dataManagementService.selectedVehicule.device.idDevice,
      entry.date,
      entry.date,
      entry
    );
    return true;
  }

  getPathDatails(idDevice: number, dateD: any, dateF: any) {
    this.formNotShown = true;
    const start = new Date(dateD);
    const end = new Date(dateF || dateD);
    const startDate = new Date(start.getTime() - 2 * 60 * 1000).toISOString();
    const endDate = new Date(end.getTime() + 2 * 60 * 1000).toISOString();
    const cachedEntry = this.findReportEntryForPoint(startDate, endDate);
    this.initTechReportMapForPoint(idDevice, startDate, endDate, cachedEntry);
  }
}